<template>
  <input v-model="searchValue" @input="setVal" @keyup.enter="serchEnterClick" class="search_inp" type="text" readonlyunselectable="on" placeholder="搜索" autocomplete="off" defaultvalue="搜索">
</template>
<script>
    export default{
        props: ['searchval','schoolid'],
        data: function () {
            return {
              searchValue:this.searchval
            }
        },
        methods: {
          setVal(){
            this.$emit('getsearchval',this.searchValue)
          },
          serchEnterClick(){
            window.location.href=`http://souke.xdf.cn/Search?cid=${this.schoolid}&kw=${this.searchValue}`
          }
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/SearchClass.vue